import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_01.png";
import Img_Two from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_02.png";
import Img_Three from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_03.png";
import Img_Four from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_04.png";
import Img_Five from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_05.png";
import Img_Six from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_06.png";
import Img_Seven from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_07.png";
import Img_Eight from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_08.png";
import Img_Nine from "./../../../../sources/imgs/BETTERCAP/BETTERCAP_09.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function BETTERCAP (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> BETTERCAP.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Introducción a BETTERCAP.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Bettercap</i> es una <span className="span-white">herramienta</span> modular para <i className="span-blue">reconocimiento</i> y <i className="span-blue">ataques MITM</i> en <span className="span-pink">redes IPv4/IPv6 (ARP/NDP/DNS/DHCP spoofers)</span>, <span className="span-pink">proxies a nivel de paquete/TCP/HTTP(S) programables</span> y un <span className="span-pink">niffer de red</span> que puede <span className="span-blue">capturar credenciales</span> y <span className="span-blue">peticiones en tiempo real</span>. Es la opción moderna frente a <span className="span-pink">Ettercap</span> por su <i className="span-blue">modularidad</i> y <i className="span-blue">scripting</i>. 
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Instalación de BETTERCAP.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <i className="span-yellow">Bettercap</i> soporta <i className="span-blue">GNU/Linux (Kali)</i>, <i className="span-blue">macOS</i>, <i className="span-blue">Windows</i> y <i className="span-blue">otros</i>. En <i className="span-yellow">Kali Linux</i> normalmente viene <span className="span-white">instalado</span>; si no, instala la <span className="span-blue">versión estable</span> o la <span className="span-blue">última</span> desde la <span className="span-white">web</span> o <span className="span-white">GitHub</span>. Para <span className="span-white">instrucciones oficiales</span> y <span className="span-white">métodos (paquetes/precompilados/Go build)</span> revisa la <span className="span-pink">página de instalación</span>. 
            </p>

            <p>
                Página oficial: 
                <a href="https://www.bettercap.org/project/installation/" target="_blank" rel="noopener noreferrer" className="span-white"><i className="span-white">https://www.bettercap.org/project/installation/</i></a>.
            </p>

            <p>
                Para la <span className="span-pink">instalación</span>, basta con <span className="span-pink">ejecutar</span> los <span className="span-white">comandos</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt update"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install bettercap"
            />

            <p>
                <span className="span-white">Donde</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"1. Comando de instalación de BETTERCAP."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Módulos importantes para ver URLs por IP con BETTERCAP.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-pink">arp.spoof</i> <i className="span-yellow">—&gt;</i>  <span className="span-white">Envenena ARP en la LAN para posicionar el atacante en el camino (MITM). </span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-pink">http.proxy</i> <i className="span-yellow">—&gt;</i> <span className="span-white">Proxy HTTP transparente, scriptable con módulos JavaScript para inspeccionar y modificar peticiones HTTP (puedes volcar URLs, cabeceras y origen IP). Útil para volcar las peticiones de la IP víctima.</span> 
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-pink">net.probe / net.sniff</i><i className="span-yellow">—&gt;</i> <span className="span-white">Descubren hosts y permiten captura/filtrado con BPF; net.sniff puede guardar pcap. </span>
                    </p>
                </li>
            </ul>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Uso de BETTERCAP.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Una vez <span className="span-pink">instalada</span> la <span className="span-white">herramienta</span>, para su uso, basta con <span className="span-pink">seguir</span> los <span className="span-white">pasos</span>:
            </p>

            <p>
                <b className="span-blue">1. Iniciar Bettercap.</b>
            </p>

            <p>
                Primeramente, debemos <span className="span-pink">inicializar</span> <i className="span-yellow">Bettercap</i> desde el modo de <span className="span-white">consola</span>:
            </p>

            <p>
                Para ello, <span className="span-pink">ejecutamos</span> el <span className="span-white">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo bettercap"
            />

            <p>
                <span className="span-white">Realizando</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"2. Comando de inicialización de BETTERCAP."}
            />

            <p>
                <b className="span-blue">2. Activar el módulo de descubrimiento de hosts.</b>
            </p>

            <p>
                Una vez <span className="span-pink">inicializada</span> la <span className="span-white">aplicación</span>, debemos <span className="span-pink">inicializar</span> el <span className="span-white">escaneo dentro de la red</span>.
            </p>

            <p>
                Para realizar esta <span className="span-pink">acción</span>, <span className="span-white">ejecutamos</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "net.probe on"
            />

            <p>
                <span className="span-white">Realizando</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando de activación de descubrimientos de host de BETTERCAP."}
            />

            <p>
                <b className="span-blue">3. Visualizar equipos dentro de la red.</b>
            </p>

            <p>
                Una vez <span className="span-pink">realizado</span> el <span className="span-white">escaneo de la red</span>, podremos <span className="span-pink">visualizar</span> los <span className="span-white">equipos conectados dentro de la red</span>.
            </p>

            <p>
                Para <span className="span-pink">mostrar</span> estos <span className="span-white">equipos detectados</span>, podemos <span className="span-pink">ejecutar</span> el <span className="span-white">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "net.show"
            />

            <p>
                Tal como se <span className="span-pink">muestra</span> en la <span className="span-white">siguiente ilustración</span>:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"4. Comando para visualizar equipos en red con BETTERCAP."}
            />

            <p>
                <span className="span-yellow">Nota: </span> Esta opción es una <span className="span-pink">variación</span> de la opcion de <span className="span-white">escaneo</span> de <i className="span-yellow">Nmap</i>, pero detectando de una mejor manera <span className="span-white">equipos más silenciosos</span>, y <span className="span-pink">SIN escaneo de puertos</span>.
            </p>

            <p>
                <b className="span-blue">4. Visualizar configuraciones activas e inactivas.</b>
            </p>

            <p>
                Tambien, si deseamos <span className="span-pink">visualizar</span> las <span className="span-blue">opciones de configuración</span> y <span className="span-blue">ayuda</span> sobre <i className="span-yellow">Bettercap</i>, podemos <span className="span-pink">ejecutar</span> el <span className="span-white">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "help"
            />

            <p>
                Tal como se <span className="span-pink">muestra</span>, a <span className="span-white">continuación</span>:
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"5. Comando de ayuda y configuración de BETTERCAP."}
            />

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"6. Comando de ayuda y configuración de BETTERCAP."}
            />

            <p>
                <b className="span-blue">5. Asignación de IP victima y activación de ARP spoof y sniff.</b>
            </p>

            <p>
                A <span className="span-white">continuación</span>, debemos <span className="span-pink">configurar</span> la(s) <i className="span-white">IP(s)</i> que serán objetivo del módulo <i className="span-white">arp.spoof</i>. Puedes usar <i className="span-blue">una sola IP</i>, <i className="span-blue">varias separadas por comas</i>, o <i className="span-blue">rangos</i> según <span className="span-pink">versión</span>.
            </p>

            <p>
                Para ello, debemos <span className="span-white">ejecutar</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "set arp.spoof.target <ip-victima>"
            />

            <p>
                Si deseamos <span className="span-pink">seleccionar</span> varias <i className="span-blue">Ips victimas</i>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "set arp.spoof.target <ip-victima>,<ip-victima-2>"
            />

            <p>
                <span className="span-yellow">Nota: </span>Este <span className="span-white">comando</span> debe <span className="span-pink">ejecutarse</span> antes de activar <i className="span-white">arp.spoof on</i>, para decirle a <i className="span-yellow">Bettercap</i> a quién <span className="span-pink">engañar</span>.
            </p>

            <p>
                Despues, <span className="span-pink">activamos</span> el <span className="span-white">envenenamiento ARP</span> entre el/los <span className="span-white">objetivo(s)</span> y el <span className="span-white">gateway</span>, situando <span className="span-blue">nuestra máquina</span> como <span className="span-white">intermediario (MITM)</span>. <span className="span-pink">Redirigiendo</span> el <span className="span-pink">tráfico de la víctima</span> a nuestro equipo para poder <i className="span-blue">capturarlo/inspeccionarlo</i>.
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "arp.spoof on"
            />

            <p>
                Si deseamos <span className="span-pink">realizar</span> otras <span className="span-white">acciones</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-white">arp.spoof off</i> — <span className="span-pink">Detener</span> el <span className="span-white">envenenamiento</span>.
                    </p>
                </li>
                <li>
                    <p>
                       <i className="span-white">set arp.spoof.internal true|false</i> — <span className="span-pink">comportamiento interno (según versión).</span>
                    </p>
                </li>
            </ul>

            <p>
                <span className="span-yellow">Nota:</span> Estas acciones pueden ser <span className="span-pink">detectadas</span> por <i className="span-blue">IDS/IPS</i> y <i className="span-blue">switches</i> gestionados con <span className="span-pink">protección ARP</span>.
            </p>

            <p>
                <span className="span-white">Finalmente</span> <span className="span-pink">iniciamos</span> la <i className="span-white">captura pasiva/activa</i> de <span className="span-white">paquetes en la interfaz</span>.
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "net.sniff on"
            />

            <p>
                Tal como se <span className="span-pink">muestra</span>, a <span className="span-white">continuación</span>:
            </p>

            <Img
                img = {Img_Seven}
                alt = {"Imagen 7. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"7. Comandos activación de ARP spoof y sniff con BETTERCAP."}
            />

            <p>
                <span className="span-pink">Mostrando</span> las <span className="span-white">capturas de trafico</span>:
            </p>
            
            <Img
                img = {Img_Eight}
                alt = {"Imagen 8. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"8. Visualización de trafico de URLs HTTPS con BETTERCAP."}
            />

            <Img
                img = {Img_Nine}
                alt = {"Imagen 9. BETTERCAP."}
                title = {"Descripcción de imagen."}
                text = {"9. Visualización de trafico de URLs HTTPS con BETTERCAP."}
            />

            <p>
                <span className="span-yellow">Nota: </span>Si configuraste set <i className="span-white">net.sniff.output &lt;ruta&gt;</i> <span className="span-pink">guardará</span> un <i className="span-blue">archivo pcap</i> con la <span className="span-white">captura</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue">Precauciones y legales.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">Recuerda siempre realizar estas pruebas con <span className="span-pink">autorización explícita</span> y por escrito. Interceptar tráfico <span className="span-pink">SIN permiso</span> es <span className="span-blue">ilegal</span>.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white"><span className="span-pink">Documenta</span>: <i className="span-blue">interfaz usada, IP objetivo, hora, duración y evidencia recolectada</i>.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-white">Ten en cuenta que <i className="span-pink">net.probe</i> y <i className="span-pink">arp.spoof</i> generan tráfico y pueden <span className="span-pink">activar alertas de seguridad</span> en la <span className="span-blue">red</span>.</span>
                    </p>
                </li>
            </ul>


        </>
    );
}